/**
 * Petdesign — Accès Pro
 * assets/pd-access-pro.js
 *
 * Script classique (pas de module) : aucun `export`, sinon SyntaxError
 * et rien ne s'exécute.
 *
 * Gère : accordéon FAQ, stepper, choix de profil, recherche INSEE
 * (nom / SIREN / SIRET), sélection d'entreprise, envoi au Worker.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-api-endpoint]').forEach(initSection);

  function initSection(ROOT) {
    var API = (ROOT.dataset.apiEndpoint || '').replace(/\/+$/, '');

    var etat = {
      profil: null,
      siret: '',
      raisonSociale: '',
      saisieManuelle: false
    };

    var MESSAGES = {
      siret_invalide: 'Ce numéro SIRET est invalide. Vérifiez les 14 chiffres.',
      siren_invalide: 'Ce numéro SIREN est invalide. Vérifiez les 9 chiffres.',
      identifiant_incomplet: 'Un SIREN compte 9 chiffres et un SIRET 14.',
      etablissement_ferme: "Cet établissement est indiqué comme fermé par l'INSEE.",
      rate_limited: 'Trop de tentatives. Patientez quelques minutes.',
      insee_unreachable: "Le service de l'INSEE est momentanément indisponible.",
      insee_quota: 'Service saturé, réessayez dans une minute.',
      recherche_trop_courte: 'Saisissez au moins 3 caractères.'
    };

    /* ══════════════════════════════════════════ Utilitaires */

    function esc(str) {
      var d = document.createElement('div');
      d.textContent = str == null ? '' : String(str);
      return d.innerHTML;
    }

    function appel(path, payload) {
      return fetch(API + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || !data.ok) {
            var err = new Error(data.message || MESSAGES[data.code] || 'Une erreur est survenue.');
            err.code = data.code;
            throw err;
          }
          return data;
        });
      });
    }

    /** Valeur d'un champ data-required, cherché dans tout le bloc donné. */
    function champ(scope, nom) {
      var el = scope ? scope.querySelector('[data-required="' + nom + '"]') : null;
      return el ? el.value.trim() : '';
    }

    function erreur(panel, message) {
      var box = panel.querySelector('[data-role="error"]');
      if (!box) return;
      if (message) {
        box.textContent = message;
        box.classList.add('active');
      } else {
        box.textContent = '';
        box.classList.remove('active');
      }
    }

    /* ══════════════════════════════════════════ FAQ */

    ROOT.querySelectorAll('.pd-ap-faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.parentElement.classList.toggle('open');
      });
    });

    /* ══════════════════════════════════════════ Stepper */

    var panneaux = {};
    ROOT.querySelectorAll('[data-panel]').forEach(function (p) {
      panneaux[p.dataset.panel] = p;
    });

    function aller(nom) {
      Object.keys(panneaux).forEach(function (k) {
        panneaux[k].classList.toggle('active', k === nom);
      });

      var n = parseInt(nom, 10);
      ROOT.querySelectorAll('.pd-ap-step').forEach(function (s) {
        var i = parseInt(s.dataset.step, 10);
        s.classList.toggle('active', i === n);
        s.classList.toggle('done', !isNaN(n) && i < n);
      });
      ROOT.querySelectorAll('.pd-ap-step-line').forEach(function (l, i) {
        l.classList.toggle('done', !isNaN(n) && i < n - 1);
      });

      var stepper = ROOT.querySelector('.pd-ap-stepper');
      if (stepper) stepper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* ══════════════════════════════════════════ Étape 1 : profil */

    ROOT.querySelectorAll('.pd-ap-profile').forEach(function (carte) {
      carte.addEventListener('click', function () {
        etat.profil = carte.dataset.profile;
        etat.siret = '';
        etat.raisonSociale = '';

        ROOT.querySelectorAll('.pd-ap-profile').forEach(function (c) {
          c.classList.toggle('selected', c === carte);
        });

        // Un seul formulaire visible à l'étape 2.
        panneaux['2'].querySelectorAll('[data-form]').forEach(function (f) {
          f.style.display = f.dataset.form === etat.profil ? 'block' : 'none';
        });

        erreur(panneaux['2'], '');
        majBoutonSuivant();
        aller('2');
      });
    });

    /* ══════════════════════════════════════════ Étape 2 : entreprise */

    function formActif() {
      return panneaux['2'].querySelector('[data-form="' + etat.profil + '"]');
    }

    /**
     * Le bouton Continuer ne s'active que si l'étape est réellement complète.
     * Chaque profil a ses propres conditions : le profil formation n'a aucune
     * entreprise à vérifier, ses deux champs texte suffisent.
     */
    function majBoutonSuivant() {
      var btn = panneaux['2'].querySelector('[data-action="next"]');
      if (!btn) return;
      var f = formActif();
      var ok = false;

      if (etat.profil === 'formation') {
        ok = !!(champ(f, 'ecole') && champ(f, 'situation'));
      } else if (etat.profil === 'salarie') {
        ok = !!(etat.siret && champ(f, 'poste'));
      } else if (etat.profil === 'professionnel') {
        ok = !!etat.siret;
      }

      // Fiche INSEE protégée : le nom saisi devient obligatoire.
      if (ok && etat.saisieManuelle && !champ(f, 'raison_sociale')) ok = false;

      btn.disabled = !ok;
    }

    panneaux['2'].addEventListener('input', majBoutonSuivant);

    /* ── Recherche INSEE ─────────────────────────────────────── */

    panneaux['2'].querySelectorAll('.pd-ap-siret-input').forEach(function (input) {
      var wrap = input.closest('.pd-ap-siret-wrap');
      var loader = wrap.querySelector('.pd-ap-siret-loader');
      var liste = wrap.querySelector('.pd-ap-suggestions');
      var minuteur = null;

      function chercher() {
        var v = input.value.trim();
        var num = v.replace(/[\s.\-]/g, '');
        var estNum = /^\d+$/.test(num);

        // On n'interroge pas l'INSEE sur un identifiant en cours de frappe.
        if (estNum && num.length !== 9 && num.length !== 14) return masquer();
        if (!estNum && v.length < 3) return masquer();

        loader.classList.add('active');
        appel('/api/pro/search', { q: v })
          .then(afficher)
          .catch(function (err) {
            liste.innerHTML = '<p class="pd-ap-suggestion-note">' + esc(err.message) + '</p>';
            liste.classList.add('active');
          })
          .then(function () { loader.classList.remove('active'); });
      }

      function masquer() {
        liste.classList.remove('active');
        liste.innerHTML = '';
      }

      function afficher(r) {
        var html = '';
        r.resultats.forEach(function (e) {
          var lieu = [e.codePostal, e.ville].filter(Boolean).join(' ');
          var detail = [lieu, 'SIRET ' + e.siret].filter(Boolean).join(' — ');
          html +=
            '<div class="pd-ap-suggestion" data-siret="' + esc(e.siret) + '">' +
            '<p class="pd-ap-suggestion-name">' + esc(e.raisonSociale) +
            (e.siegeSocial && r.type === 'siren' ? ' (siège)' : '') + '</p>' +
            '<p class="pd-ap-suggestion-detail">' + esc(detail) + '</p>' +
            '</div>';
        });
        if (!r.resultats.length) {
          html += '<p class="pd-ap-suggestion-note">Aucun établissement trouvé.</p>';
        }
        if (r.note) {
          html += '<p class="pd-ap-suggestion-note">' + esc(r.note) + '</p>';
        }
        liste.innerHTML = html;
        liste.classList.add('active');
      }

      // Anti-rafale : une frappe ne doit pas égaler un appel INSEE.
      input.addEventListener('input', function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(chercher, 450);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); clearTimeout(minuteur); chercher(); }
      });

      liste.addEventListener('click', function (e) {
        var item = e.target.closest('[data-siret]');
        if (!item) return;
        masquer();
        verifier(item.dataset.siret, input);
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) masquer();
      });
    });

    /* ── Vérification et affichage de la fiche ───────────────── */

    function verifier(siret, input) {
      var f = formActif();
      var apercu = f.querySelector('[data-role="company-preview"]');
      var manuel = f.querySelector('[data-role="manual-name"]');

      erreur(panneaux['2'], '');

      appel('/api/pro/verify', { siret: siret }).then(function (r) {
        etat.siret = siret;
        etat.saisieManuelle = !!r.saisieManuelle;
        etat.raisonSociale = r.entreprise ? r.entreprise.raisonSociale : '';

        if (input) input.value = etat.raisonSociale || siret;

        if (r.entreprise) {
          remplir(apercu, 'name', r.entreprise.raisonSociale);
          remplir(apercu, 'siret', r.entreprise.siret);
          remplir(apercu, 'tva', r.entreprise.tvaIntracom);
          remplir(apercu, 'address', (r.entreprise.adresse || '').replace(/\n/g, ', '));
          remplir(apercu, 'naf', r.entreprise.codeApe);
          apercu.classList.add('active');
        } else {
          // Fiche protégée ou immatriculation trop récente : l'INSEE confirme
          // l'existence sans livrer les détails. On n'affiche pas de fiche vide.
          apercu.classList.remove('active');
        }

        if (manuel) {
          manuel.style.display = etat.saisieManuelle ? 'block' : 'none';
          if (etat.saisieManuelle && r.message) erreur(panneaux['2'], r.message);
        }

        majBoutonSuivant();
      }).catch(function (err) {
        etat.siret = '';
        etat.saisieManuelle = false;
        apercu.classList.remove('active');
        if (manuel) manuel.style.display = 'none';
        erreur(panneaux['2'], err.message);
        majBoutonSuivant();
      });
    }

    /** Remplit un champ de la fiche et masque la ligne si la valeur est vide. */
    function remplir(apercu, nom, valeur) {
      var el = apercu.querySelector('[data-field="' + nom + '"]');
      if (!el) return;
      el.textContent = valeur || '';
      var ligne = el.closest('.pd-ap-company-detail');
      if (ligne) ligne.style.display = valeur ? '' : 'none';
    }

    /* ══════════════════════════════════════════ Navigation */

    ROOT.querySelectorAll('[data-action="back"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        aller(btn.closest('[data-panel]').dataset.panel === '3' ? '2' : '1');
      });
    });

    var suivant = panneaux['2'].querySelector('[data-action="next"]');
    if (suivant) {
      suivant.addEventListener('click', function () {
        erreur(panneaux['3'], '');
        // Pré-remplissage si le visiteur est déjà connecté.
        if (ROOT.dataset.customerEmail) {
          var mail = panneaux['3'].querySelector('[data-required="email"]');
          if (mail && !mail.value) mail.value = ROOT.dataset.customerEmail;
        }
        aller('3');
      });
    }

    /* ══════════════════════════════════════════ Étape 3 : envoi */

    var envoyer = panneaux['3'].querySelector('[data-action="submit"]');
    if (envoyer) {
      envoyer.addEventListener('click', function () {
        var p3 = panneaux['3'];
        var f = formActif();

        var email = champ(p3, 'email');
        var prenom = champ(p3, 'first_name');
        var nom = champ(p3, 'last_name');

        if (!prenom || !nom) return erreur(p3, 'Prénom et nom sont requis.');
        if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) {
          return erreur(p3, 'Adresse email invalide.');
        }
        erreur(p3, '');

        var optin = p3.querySelector('.pd-ap-optin-checkbox');

        var payload = {
          profil: etat.profil,
          siret: etat.siret,
          raison_sociale: champ(f, 'raison_sociale') || etat.raisonSociale,
          email: email,
          prenom: prenom,
          nom: nom,
          telephone: champ(p3, 'phone'),
          poste: champ(f, 'poste'),
          ecole: champ(f, 'ecole'),
          situation: champ(f, 'situation'),
          newsletter: !!(optin && optin.checked),
          website: champ(p3, 'website') // piège à robots
        };

        envoyer.disabled = true;
        var libelle = envoyer.innerHTML;
        envoyer.textContent = 'Envoi…';

        appel('/api/pro/apply', payload).then(function (r) {
          var titre = ROOT.querySelector('[data-role="success-title"]');
          var texte = ROOT.querySelector('[data-role="success-text"]');

          // Deux fins de parcours possibles : accès ouvert immédiatement,
          // ou demande mise en attente de vérification manuelle.
          if (!r.accesImmediat) {
            if (titre) titre.innerHTML = 'Demande <em>enregistrée</em>.';
            if (texte) texte.textContent = r.message;
          }
          aller('success');
        }).catch(function (err) {
          erreur(p3, err.message);
        }).then(function () {
          envoyer.disabled = false;
          envoyer.innerHTML = libelle;
        });
      });
    }
  }
})();